// src/App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Import Router components
import HomePage from './components/HomePage'; // Import HomePage component
import About from './components/About'; // Import AboutPage component
import Browse from './components/Browse';
import Downloads from './components/Downloads';
import Navbar from './components/Navbar'; // Import Navbar component
import Footer from './components/Footer';
import ProteinDetail from './components/ProteinDetail'
import './App.css'; // Import global styles
import './static/css/tailwind.css'; // Tailwind CSS

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} /> {/* Route for HomePage */}
          <Route path="/about" element={<About />} /> {/* Route for AboutPage */}
          <Route path="/browse" element={<Browse />} /> {/* Route for Browse Page */}
          <Route path="/downloads" element={<Downloads />} /> {/* Route for Browse Page */}
          <Route path="/proteins/:id" element={<ProteinDetail />} /> {/* Dynamic route for protein details */}
        </Routes>
          <Footer />
      </div>
    </Router>
  );
}

export default App;


      /*
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
       */
